import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Page, PageHeader, PageTitle } from "components/ui/Page";
import {
  PageColumn,
  EvenThirdsLayout,
  ColumnAtBreakpoint,
  ColumnUnlessBreakpoint,
} from "components/ui/PageColumns";
import AdvisorDegreeProgressLoader from "components/AdvisorDegreeProgressLoader";
import AdvisorStatusAndHoldsCard from "components/cards/AdvisorStatusAndHoldsCard";
import AdvisorAcademicAdvisingCard from "components/cards/AdvisorAcademicAdvisingCard";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { StudentSummaryCard } from "components/cards/StudentSummaryCard";
import { StudentSuccessCard } from "components/cards/StudentSuccessCard";
import AcademicPlanCard from "components/cards/AcademicPlanCard";
import { setTargetUserId } from "data/actions/advisingActions";
import { AdvisingTransferCreditCard } from "components/cards/TransferCreditCard";
import { AdvisorHigherDegreeCommitteesCard } from "components/cards/AdvisorHigherDegreeCommitteesCard";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Student+Overview+Page
export default function AdvisorUserOverviewPage() {
  const dispatch = useDispatch();
  const { uid } = useParams();

  useEffect(() => {
    if (uid) {
      dispatch(setTargetUserId(uid));
    }
  }, [dispatch, uid]);

  return (
    <Page>
      <PageTitle title="Student Overview" />
      <PageHeader>
        <Link to="/dashboard">My Dashboard</Link> &raquo; Student Overview
      </PageHeader>
      <LargeSpacer />
      <EvenThirdsLayout>
        <PageColumn>
          <StudentSummaryCard />
          <AdvisorAcademicAdvisingCard uid={uid} />
        </PageColumn>
        <ColumnAtBreakpoint breakpointName="medium">
          <ColumnUnlessBreakpoint breakpointName="medium">
            <AcademicPlanCard />
          </ColumnUnlessBreakpoint>

          <ColumnUnlessBreakpoint breakpointName="medium">
            <AdvisorHigherDegreeCommitteesCard />
            <AdvisorStatusAndHoldsCard />
            <AdvisorDegreeProgressLoader />
            <AdvisingTransferCreditCard />
            <StudentSuccessCard />
          </ColumnUnlessBreakpoint>
        </ColumnAtBreakpoint>
      </EvenThirdsLayout>
    </Page>
  );
}
AdvisorUserOverviewPage.displayName = "AdvisorUserOverviewPage";
